import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SrBox from 'client/components/SrBox';
import SrIcon from 'client/components/SrIcon';

function _onSrModalContentClick(event) {
  event.stopPropagation();
}

function getWidthStyles(width) {
  if (!width) {
    return {};
  }
  return {
    width: `${width}px`,
  };
}

const SrModalContent = ({
  onCloseIconClick,
  children,
  width,
  dynamicHeight,
  style,
  innerStyle,
}) => (
  <div
    className={classnames(
      'SrModalContent',
      dynamicHeight && 'dynamicHeight',
    )}
    style={{ ...(style || {}), ...getWidthStyles(width) }}
    onClick={_onSrModalContentClick}
  >
    {onCloseIconClick && (
      <SrBox
        position='absolute'
        zIndex='9999'
        onClick={onCloseIconClick}
        className='closeButton'
      >
        <SrIcon className='x-close-large-white' />
      </SrBox>
    )}
    <div className='inner' style={innerStyle}>
      {children}
    </div>
  </div>
);

SrModalContent.propTypes = {
  onCloseIconClick: PropTypes.func,
  children: PropTypes.node,
  width: PropTypes.number,
  dynamicHeight: PropTypes.bool,
  style: PropTypes.object,
  innerStyle: PropTypes.object,
};

SrModalContent.displayName = 'SrModalContent';

export default SrModalContent;
